
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { supabaseBackend } from './supabaseBackend';

export const initializeI18n = async (communityId: string) => {
  console.log('[i18n] Initializing i18next with communityId:', communityId);
  
  return i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(supabaseBackend({
      getCommunityId: () => communityId
    }))
    .init({
      fallbackLng: 'en_GB',
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
      },
      react: {
        useSuspense: false
      }
    });
};

export default i18n;

